var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Outlet } from "react-router-dom";
import PageContainer from "../../components/container/PageContainer";
import LpHeader from './header/Header';
import LpFooter from './footer/Footer';
import { useState, useCallback } from "react";
import Box from "@mui/material/Box";
var LandingLayoutNoAuth = function (_a) {
    var _b = _a.showHeader, showHeader = _b === void 0 ? true : _b, _c = _a.showFooter, showFooter = _c === void 0 ? true : _c, _d = _a.narrowHeader, narrowHeader = _d === void 0 ? false : _d;
    var _e = useState(0), headerHeight = _e[0], setHeaderHeight = _e[1];
    var handleHeaderHeightChange = useCallback(function (height) {
        setHeaderHeight(height);
    }, []);
    return (_jsxs(PageContainer, __assign({ title: "Homepage", description: "Landing page" }, { children: [showHeader ? (_jsxs(_Fragment, { children: [_jsx(LpHeader, { narrowHeader: narrowHeader, onHeightChange: handleHeaderHeightChange }), _jsx(Box, { sx: { height: headerHeight } })] })) : null, _jsx(Outlet, {}), showFooter ? _jsx(LpFooter, {}) : null] })));
};
export default LandingLayoutNoAuth;
